export default "__VITE_ASSET__1b6df068__"